import { DownloadInstallationsDialog } from "@/features/installations/components/DownloadInstallationsDialog";
import type { User } from "@/features/users/schemas/user";

interface UserInstallationsDialogProps {
  user: User | null;
  open: boolean;
  onClose: () => void;
}

/**
 * Wrapper that connects the download installations dialog with a user context.
 * Used from UserActionsDialog when the "installations" action is triggered.
 */
export function UserInstallationsDialog({
  user,
  open,
  onClose,
}: UserInstallationsDialogProps) {
  return <DownloadInstallationsDialog user={user} open={open} onClose={onClose} />;
}
